// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Tq-z","sponsoredTooltipWrapper":"Uq-z","sponsoredTooltip":"Vq-z","newCard":"Wq-z"};